import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  SearchBar } from '../../components';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const OrderManagementList = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetchOrders = () => {
      // axios.get('/api/orders').then(response => {
      //   if (mounted) {
      //     setOrders(response.data.orders);
      //   }
      // });
      setOrders([{
        id: uuid(),
        created_at: moment().subtract(10, 'minutes'),
        customer: {
          name: 'Ekaterina Tankova'
        },
        payment: {
          ref: 'DRV103',
          method: 'CreditCard',
          total: '500.00',
          currency: '₹ ',
          status: 'pending'
        },
        status: 'inactive'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(32, 'minutes')
          .subtract(23, 'seconds'),
        customer: {
          name: 'Cao Yu'
        },
        payment: {
          ref: 'DRV102',
          method: 'CreditCard',
          total: '500.00',
          currency: '₹ ',
          status: 'pending'
        },
        status: 'inactive'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(36, 'minutes')
          .subtract(51, 'seconds'),
        customer: {
          name: 'Alexa Richardson'
        },
        payment: {
          ref: 'DRV101',
          method: 'PayPal',
          total: '500.00',
          currency: '₹ ',
          status: 'completed'
        },
        status: 'active'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(38, 'minutes')
          .subtract(55, 'seconds'),
        customer: {
          name: 'Anje Keizer'
        },
        payment: {
          ref: 'DRV100',
          method: 'CreditCard',
          total: '500.00',
          currency: '₹ ',
          status: 'pending'
        },
        status: 'inactive'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(40, 'minutes')
          .subtract(3, 'seconds'),
        customer: {
          name: 'Clarke Gillebert'
        },
        payment: {
          ref: 'DRV99',
          method: 'PayPal',
          total: '500.00',
          currency: '₹ ',
          status: 'completed'
        },
        status: 'active'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(45, 'minutes')
          .subtract(32, 'seconds'),
        customer: {
          name: 'Adam Denisov'
        },
        payment: {
          ref: 'DRV98',
          method: 'PayPal',
          total: '500.00',
          currency: '₹ ',
          status: 'completed'
        },
        status: 'active'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(48, 'minutes')
          .subtract(57, 'seconds'),
        customer: {
          name: 'Ava Gregoraci',
          avatar: '/images/avatars/avatar_8.png'
        },
        payment: {
          ref: 'DRV97',
          method: 'CreditCard',
          total: '500.00',
          currency: '₹ ',
          status: 'pending'
        },
        status: 'inactive'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(49, 'minutes')
          .subtract(4, 'seconds'),
        customer: {
          name: 'Emilee Simchenko'
        },
        payment: {
          ref: 'DRV96',
          method: 'CreditCard',
          total: '500.00',
          currency: '₹ ',
          status: 'completed'
        },
        status: 'active'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(57, 'minutes')
          .subtract(43, 'seconds'),
        customer: {
          name: 'Kwak Seong-Min'
        },
        payment: {
          ref: 'DRV95',
          method: 'PayPal',
          total: '500.00',
          currency: '₹ ',
          status: 'rejected'
        },
        status: 'inactive'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(59, 'minutes')
          .subtract(6, 'seconds'),
        customer: {
          name: 'Shen Zhi'
        },
        payment: {
          ref: 'DRV94',
          method: 'CreditCard',
          total: '500.00',
          currency: '₹ ',
          status: 'canceled'
        },
        status: 'inactive'
      },
      {
        id: uuid(),
        created_at: moment()
          .subtract(1, 'hour')
          .subtract(15, 'minutes')
          .subtract(43, 'seconds'),
        customer: {
          name: 'Merrile Burgett'
        },
        payment: {
          ref: 'DRV93',
          method: 'PayPal',
          total: '500.00',
          currency: '₹ ',
          status: 'canceled'
        },
        status: 'inactive'
      }
    ])
    };

    fetchOrders();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Page
      className={classes.root}
      title="Orders Management List"
    >
      <Header />
      <SearchBar />
      <Results
        className={classes.results}
        orders={orders} //
      />
    </Page>
  );
});

export default OrderManagementList;
